import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function PersonnelTypeEditForm({ 
  personnelType,
  btnRef,
  savePersonnelType
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={personnelType}
      onSubmit={(values) => savePersonnelType(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Adı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="definition">
            <Form.Label column sm={2}>
              Tanımı
            </Form.Label>
            <Col sm={10}>
              <Form.Control as="textarea" rows="3" value={values.definition} placeholder="Tanımı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}